import {
  FETCH_ADMIN_AFFILIATES_REQUEST,
  FETCH_ADMIN_AFFILIATES_SUCCESS,
  FETCH_ADMIN_AFFILIATES_FAILURE,
  ADD_AFFILIATE_REQUEST,
  ADD_AFFILIATE_SUCCESS,
  ADD_AFFILIATE_FAILURE,
  EDIT_AFFILIATE_REQUEST,
  EDIT_AFFILIATE_SUCCESS,
  EDIT_AFFILIATE_FAILURE,
  DELETE_AFFILIATE_REQUEST,
  DELETE_AFFILIATE_SUCCESS,
  DELETE_AFFILIATE_FAILURE,
} from './adminAffliatesActionType';
import axios from 'axios';
import { alertAction } from '../Alert/alertActions';
import { loaderAction } from '../loader/loaderActions';

//////////////////////////////////////// GET AFFILIATES ///////////////////////////////////////////////
interface AFFILIATES {
  AppUserID: number;
  AffiliateName: Array<string>;
  UserName: string;
  Email: string;
  Detail: any;
}
interface Header {
  AffiliateName: Array<string>;
  UserName: string;
  UserEmail: string;
  Email: string;
  Password: string;
  IsNewPassword: boolean;
}
interface HeaderEdit {
  AffiliateName: Array<string>;
  UserName: string;
  UserID: number;
  Email: string;
  Password: string;
  IsNewPassword: boolean;
}

const fetchAdminAffiliateRequest: any = () => {
  return {
    type: FETCH_ADMIN_AFFILIATES_REQUEST,
  };
};

const fetchAdminAffiliateSuccess: any = (AFFILIATES: AFFILIATES) => {
  return {
    type: FETCH_ADMIN_AFFILIATES_SUCCESS,
    payload: AFFILIATES,
  };
};

const fetchAdminAffiliateFailure: any = (error: string) => {
  return {
    type: FETCH_ADMIN_AFFILIATES_FAILURE,
    payload: error,
  };
};

export const fetchAdminAffiliates: any = () => {

  return function (dispatch: any) {
    dispatch(loaderAction(true) as any);
    dispatch(fetchAdminAffiliateRequest());

    axios
      .get(`${import.meta.env.VITE_BACKEND}api/UserAffiliateManage/GetUserAffiliates`)
      .then((response) => {
        const AFFILIATES = response.data;
        AFFILIATES.forEach((obj: any) => {
          if (obj.AffiliateName !== null) {
            obj.AffiliateName = obj.AffiliateName.split(',');
          }
        });
        dispatch(fetchAdminAffiliateSuccess(AFFILIATES));
        dispatch(loaderAction(false) as any);
      })
      .catch((error) => {
        const errorMsg = error.response?.data?.Details || error.response?.data?.Message || 'An unexpected error occurred.';
        dispatch(fetchAdminAffiliateFailure(errorMsg));
        dispatch(alertAction(errorMsg, true, 'error') as any);
        dispatch(loaderAction(false) as any);
      });
  };
};

//////////////////////////////////////// ADD AFFILIATE ///////////////////////////////////////////////

const addAffiliateRequest: any = () => {
  return {
    type: ADD_AFFILIATE_REQUEST,
  };
};

const addAffiliateSuccess: any = (AFFILIATE: AFFILIATES) => {
  return {
    type: ADD_AFFILIATE_SUCCESS,
    payload: AFFILIATE,
  };
};

const addAffiliateFailure: any = (error: string) => {
  return {
    type: ADD_AFFILIATE_FAILURE,
    payload: error,
  };
};

export const addAffiliate: any = (headerValue: Header) => {
  return function (dispatch: any) {
    dispatch(addAffiliateRequest());
    dispatch(loaderAction(true) as any);
    axios({
      method: 'post',
      url: `${import.meta.env.VITE_BACKEND}api/UserAffiliateManage/SaveUserAffiliates`,
      withCredentials:true,
      headers: {
        UserAffiliateFilter: JSON.stringify(headerValue),
        'Content-Type': 'application/json'
      },
    })
      .then((response) => {
        const AFFILIATES = response.data;
        dispatch(addAffiliateSuccess(AFFILIATES));
        dispatch(alertAction('A new user has been created and an email has been sent.', true, 'success'));
        dispatch(fetchAdminAffiliates());
        dispatch(loaderAction(false) as any);
      })
      .catch((error) => {
        const errorMsg = error.response?.data?.Details || error.response?.data?.Message || 'An unexpected error occurred.';
        dispatch(alertAction(errorMsg, true, 'error') as any);
        dispatch(addAffiliateFailure(errorMsg));
        dispatch(loaderAction(false) as any);
      });
  };
};

//////////////////////////////////////// EDIT AFFILIATE ///////////////////////////////////////////////

const editAffiliateRequest: any = () => {
  return {
    type: EDIT_AFFILIATE_REQUEST,
  };
};

const editAffiliateSuccess: any = (AFFILIATE: AFFILIATES) => {
  return {
    type: EDIT_AFFILIATE_SUCCESS,
    payload: AFFILIATE,
  };
};

const editAffiliateFailure: any = (error: string) => {
  return {
    type: EDIT_AFFILIATE_FAILURE,
    payload: error,
  };
};

export const editAffiliate: any = (headerValue: HeaderEdit) => {
  return function (dispatch: any) {
    dispatch(editAffiliateRequest());
    dispatch(loaderAction(true) as any);

    axios({
      method: 'post',
      url: `${import.meta.env.VITE_BACKEND}api/UserAffiliateManage/UpdateUserAffiliates`,
      withCredentials:true,
      headers: {
        UserAffiliateFilter: JSON.stringify(headerValue),
      },
    })
      .then((response) => {
        const AFFILIATES = response.data;
        dispatch(editAffiliateSuccess(AFFILIATES));
        dispatch(alertAction('User Edit Successfully ...', true, 'success'));
        dispatch(fetchAdminAffiliates());
        dispatch(loaderAction(false) as any);
      })
      .catch((error) => {
        const errorMsg = error.response?.data?.Details || error.response?.data?.Message || 'An unexpected error occurred.';
        dispatch(alertAction(errorMsg, true, 'error') as any);
        dispatch(editAffiliateFailure(errorMsg));
        dispatch(loaderAction(false) as any);
      });
  };
};

////////////////////////////////////// DELETE AFFILIATE //////////////////////////////////////

const deleteAffiliateRequest: any = () => {
  return {
    type: DELETE_AFFILIATE_REQUEST,
  };
};

const deleteAffiliateSuccess: any = (AFFILIATE: AFFILIATES) => {
  return {
    type: DELETE_AFFILIATE_SUCCESS,
    payload: AFFILIATE,
  };
};

const deleteAffiliateFailure: any = (error: string) => {
  return {
    type: DELETE_AFFILIATE_FAILURE,
    payload: error,
  };
};

export const deleteAffiliate: any = (deleteId: string) => {
  return function (dispatch: any) {
    dispatch(deleteAffiliateRequest());
    dispatch(loaderAction(true) as any);

    axios({
      method: 'post',
      url: `${import.meta.env.VITE_BACKEND}api/UserAffiliateManage/DeleteUser`,
      data: deleteId,
      withCredentials:true,
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json-patch+json',
      },
    })
      .then((response) => {
        const AFFILIATES = response.data;
        dispatch(deleteAffiliateSuccess(AFFILIATES));
        dispatch(alertAction('User Deleted Successfully ...', true, 'success'));

        dispatch(fetchAdminAffiliates());
        dispatch(loaderAction(false) as any);
      })
      .catch((error) => {
        const errorMsg = error.response?.data?.Details || error.response?.data?.Message || 'An unexpected error occurred.';
        dispatch(alertAction(errorMsg, true, 'error'));
        dispatch(deleteAffiliateFailure(errorMsg));
        dispatch(loaderAction(false) as any);
      });
  };
};

////////////////////////////////////// TOGGLE ADMIN ROLE //////////////////////////////////////

export const toggleAdminRole: any = (appuserId: number, userEmail: string, isCurrentlyAdmin: boolean) => {
  const endpoint = isCurrentlyAdmin ? 'DeleteAdminRoleFromUser' : 'AddAdminRoleToUser';
  return function (dispatch: any) {
    dispatch(loaderAction(true) as any);
    axios({
      method: 'post',
      url: `${import.meta.env.VITE_BACKEND}api/Users/${endpoint}`,
      data: { appuserId, userEmail },
      withCredentials: true,
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json-patch+json',
      },
    })
      .then(async (response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(alertAction(isCurrentlyAdmin ? 'Admin role revoked' : 'Admin role granted', true, 'success'));
          await dispatch(fetchAdminAffiliates());
        } else {
          dispatch(alertAction(`${response.data?.Message || 'Failed to update admin role'}`, true, 'error'));
        }
        dispatch(loaderAction(false) as any);
      })
      .catch((error) => {
        dispatch(alertAction(`${error.response?.data?.Message || 'Failed to update admin role'}`, true, 'error'));
        dispatch(loaderAction(false) as any);
      });
  };
};
